{
  "addMoreRooms": "Добавете още стаи",
  "addMoreRoomsOrBook": "Разгледайте допълнителни стаи или продължете с резервацията",
  "addToCart": "Добави",
  "address": "Адрес",
  "adults": "Възрастни",
  "agreeWithTerms": "Съгласен съм с условията за ползване",
  "alreadyHaveProfile": "Вече имате профил",
  "apartment": "Апартамент",
  "applyFilter": "Филтрирай",
  "availableRooms": "Налични стаи",
  "average": "Средно",
  "bookingFilterInfo": "Моля, изберете дати",
  "buy": "Купи",
  "callUs": "Обадете ни се",
  "changeRooms": "Смени стаите",
  "checkIn": "Настаняване",
  "checkOut": "Напускане",
  "checkout": "Поръчка",
  "city": "Град",
  "close": "Затвори",
  "companyEmail": "Фирмен имейл",
  "companyName": "Име на фирма",
  "confirm": "Потвърди",
  "contactMailSent": "Вашето съобщение, беше изпратено успешно. Ще се свържем с Вас при първа възможност!",
  "count": "Брой",
  "country": "Държава",
  "dates": "Дати",
  "delivery": "Доставка",
  "deliveryData": "Данни за доставка",
  "description": "Описание",
  "eik": "ЕИК",
  "email": "Имейл",
  "enableNotifications": "Включи известия",
  "enableNotificationsInfo": "Включете известията за да получавате най-новите ни оферти и промоции",
  "enableNotificationsInfoOff": "Съжаляваме, но вашите известия са изключени. За да не изпуснете някоя от нашите страхотни оферти Ви молим да позволите получаването на известия",
  "entrance": "Вход",
  "errors": "Грешки",
  "fillYourReservationInfo": "Информация за резервация",
  "fillYourReservationInfoSub": "Моля, предоставете данните за вашата резервация",
  "filter": "Филтър",
  "finishOrder": "Завърши поръчка",
  "firstName": "Първо име",
  "floor": "Етаж",
  "for": "За",
  "forPeriod": "Избрани дати",
  "forgotYourPassword": "Забравихте си паролата?",
  "from": "От",
  "from_date": "От дата",
  "gdprText": "С изпращането на това запитване към нас Вие предоставяте Ваши лични данни, които ние ще обработваме и съхраняваме съгласно Общия регламент за защита на данните на Европейския съюз (GDPR) и нашата Политика за конфиденциалност на данните , с която вие се съгласявате",
  "guests": "Гости",
  "inStock": "В наличност",
  "invoiceData": "Данни за фактура",
  "keepYourReservationNumbers": "Моля, запазете номерата на вашата резервация!",
  "kid": "Дете",
  "kidYears": "Години на дете",
  "kids": "Деца",
  "lastName": "Фамилия",
  "locale": "bg-BG",
  "login": "Вход",
  "logout": "Изход",
  "message": "Съобщение",
  "mol": "МОЛ",
  "moreFrom": "Още ",
  "night": "нощ",
  "nights": "нощи",
  "noMoreRoom": "Няма налични стаи",
  "noRoomSelected": "Няма избрани стаи",
  "note": "Забележка",
  "numberOfGuests": "Брой възрастни",
  "numberOfKids": "Брой деца",
  "order": "Поръчка",
  "orderFor": "Поръчка за",
  "orderNow": "Поръчай",
  "outOfStock": "Няма наличност",
  "password": "Парола",
  "paymentMethod": "Метод на плащане",
  "perNight": "за нощ",
  "phone": "Телефон",
  "pleaseSelectRoomsFirst": "Моля, изберете поне една стая, за да продължите с резервацията.",
  "postCode": "Пощ. код",
  "price": "Цена",
  "priceFrom": "Цена от",
  "product": "Продукт",
  "products": "Продукти:",
  "quarter": "Квартал",
  "readyProfile": "Вече имате профил?",
  "recover": "Възстанови",
  "reference": "Референция",
  "register": "Регистрация",
  "repeatPassword": "Повтори парола",
  "request": "Заявка",
  "requestPasswordChange": "Заяви парола",
  "requireInvoice": "Желая фактура",
  "reservation": "Резервация",
  "reservationDone": "Резервацията беше успешна!",
  "reservationSuccess": "Резервацията е успешна!",
  "reserve": "Резервирай",
  "returnPolicy": "Политика за връщане",
  "room": "Стая",
  "roomSelected": "Стаята е избрана!",
  "rooms": "Стаи",
  "saveAReservationHour": "Запази час",
  "search": "Търсене",
  "searchResult": "Резултати",
  "select": "Избери",
  "selectAdultsAndKids": "Изберете броя на възрастни и деца",
  "selectCity": "Град",
  "selectCountry": "Държава",
  "selectGuests": "Изберете гости",
  "selectOffice": "Изберете офис",
  "selectRoom": "Изберете",
  "selectRooms": "Изберете стаи",
  "selectVariation": "Оферти за тази стая",
  "selectedPeriodIsInvalid": "Невалидни дати",
  "sendMessage": "Изпрати запитване",
  "serviceRequested": "Услугата е заявена",
  "street": "Улица",
  "streetNumber": "Номер",
  "subject": "Тема",
  "sure": "Потвърди",
  "temporaryNotAvailable": "Временно недостъпно",
  "toAddress": "До адрес",
  "toOffice": "До офис",
  "to_date": "До дата",
  "total": "Общо",
  "totalSum": "Обща сума",
  "variations": "Вариянти",
  "vat": "ДДС номер",
  "view": "Преглед",
  "viewMore": "Виж още",
  "weOfferYou": "Предлагаме",
  "yearsOld": "Годишно",
  "yourCart": "Вашата количка",
  "yourCartIsEmpty": "Вашата количка е празна",
  "yourData": "Вашите данни",
  "yourEmail": "Имейл",
  "yourName": "Име",
  "yourOrder": "Поръчка",
  "yourPhone": "Телефон",
  "yourProducts": "Продукти",
  "adultsCount": "Брой възрастни",
  "kidsCount": "Брой деца",
  "readyToPay": "Към плащане",
  "bgn": "лв.",
  "calculatingPrice": "Изчисляване на цената",
  "selectAdultsAndKidsInfo": "Моля, изберете броя на възрастните и децата, които ще присъстват:",
  "kids3yearsAreFree": "За деца до 3 години е безплатно.",
  "reservationNumber": "Номер на резервация",
  "totalPrice": "Обща цена",
  "maxPeriodOfDays": "Избраният период може да бъде максимум 14 дни",
  "parking": "Паркинг",
  "luggage": "Багаж",
  "bar": "Бар",
  "breakfast": "Закуска",
  "pay": "Плати",
  "cancel": "Отказ",
  "completePurchase": "Завършете покупката си",
  "home": "Начало",
  "calendar": "Календар",
  "profile": "Профил",
  "promo_code": "Промо код",
  "newReservation": "Нова резервация"
}